import { Location, NgClass, NgStyle } from '@angular/common';
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppService } from '@core/services/app.service';
import { GlobalHandlerService } from '@core/services/global-handler.service';
import { SharedService } from '@core/services/shared.service';
import { isDefined } from '@shared/heplers/helpers';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';
import { CustomFooterComponent } from './footer/custom-footer/custom-footer.component';
import { FooterOneComponent } from './footer/footer-one/footer-one.component';
import { MainHeaderComponent } from './header/main-header.component';
import { fromEvent } from 'rxjs'
import {  debounceTime } from 'rxjs/operators'
import { customEcommerce } from 'src/assets/custom-ecommerce/custom';

@Component({
    selector: 'app-fuse-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [MainHeaderComponent, RouterOutlet, FooterOneComponent, NgClass, NgStyle, CustomFooterComponent]
})
export class FuseMainComponent implements OnInit, OnDestroy, AfterViewInit {
  private appService = inject(AppService);
  private keycloakAngular = inject(KeycloakService);
  private router = inject(Router);
  private location = inject(Location);
  private globalHandlerService = inject(GlobalHandlerService);
  private route = inject(ActivatedRoute);
  private sharedService = inject(SharedService);

  @ViewChild('mainHeader') mainHeader!: ElementRef;

  logined = false;
  areInPrRoutes : boolean
  isCustom:boolean = false;
  isBrixen:boolean = false;
  isWebMobile : boolean 
  private lastHideScrollTop = 0;
  private lastScrollTop = 0;
  hideHeader: boolean = false;
  forceHeaderVisible: boolean = false;
  forceHeaderSolidBgColor: boolean = false;
  contentMarginTop: number = 104;

  private routerSubscription: Subscription;
  private scrollSubscription: Subscription;
  private headerPropertiesSubscription: Subscription;

  ngOnInit() {
     this.checkScreen();
    window.addEventListener('resize', () => this.checkScreen());
      this.setupScrollListener();
    this.isCustom = this.sharedService.checkRoute();
    this.isBrixen = this.isCustom && customEcommerce[this.sharedService.getCustomDomain()]?.domain === 'brixen';
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
       this.areInPrRoutes = this.sharedService.checkCurrentRoute(event.url);
      }
    });
    this.keycloakAngular.isLoggedIn().then(logined => {
      this.logined = logined;
      if (this.logined) {
        this.checkCompletedProfile();
      }
    });
    this.headerPropertiesSubscription = this.sharedService.forceMainHeaderProperties$.subscribe(
      (properties: {visible: boolean, solidBgColor?: boolean}) => {
        this.forceHeaderVisible = properties.visible;
        this.hideHeader = false;
        this.forceHeaderSolidBgColor = properties.solidBgColor || false;
      }
    );
  }

  ngAfterViewInit() {
    this.updateHeaderHeight();
  }

  updateHeaderHeight() {
    if (this.mainHeader && this.mainHeader.nativeElement.offsetHeight > 104) {
      this.contentMarginTop = this.mainHeader.nativeElement.offsetHeight;
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.scrollSubscription.unsubscribe();
    this.headerPropertiesSubscription.unsubscribe();
  }

  checkScreen() {
    this.isWebMobile = window.innerWidth < 767;
  }

  checkCompletedProfile() {
    const currentUrl = this.location.path();
    if (!currentUrl.startsWith('/il-mio-profilo')){
      this.appService.getElement('auth/myprofile').subscribe((response: any) => {
        if (response && isDefined(response.completed) && response.completed === false) {
          this.router.navigate( ['/il-mio-profilo'], { queryParams: { redirectUrl: currentUrl ? currentUrl : '/home' }});
        }
      }, (error) => {
        this.globalHandlerService.showError(error);
      });
    }
  }

  handelScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (this.forceHeaderVisible) {
      this.hideHeader = false;
    } else if (currentScroll > this.lastScrollTop && currentScroll > 110) {
      this.hideHeader = true;
      this.lastHideScrollTop = currentScroll;
    } else if (currentScroll < this.lastScrollTop && this.lastHideScrollTop - currentScroll >= 75) {
      this.hideHeader = false;
    }
    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }


  setupScrollListener(): void {
    this.scrollSubscription = fromEvent(window, 'scroll')
      .pipe(debounceTime(15))
      .subscribe(() => this.handelScroll());
  }
}
